import { createSlice } from "@reduxjs/toolkit";

const loadDashboardState = (id) => {
    const savedState = localStorage.getItem(`dashboardState-${id}`);
    return savedState
        ? JSON.parse(savedState)
        : {
            openedWidgets: [],
            topFilters: [],
            topConcepts: [],
            selections: {},
            activeConceptList: "top",
            filterState: {
                deselection: "",
                deselectionConcepts: "",
                deselectionDate: null,
                topOptionsConcepts: [],
                totalDocCount: 0,
            },
        };
};

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: { openedWidgets: [],
        topFilters: [],
        topConcepts: [],
        selections: {},
        activeConceptList: "top",
        filterState: {
            deselection: "",
            deselectionConcepts: "",
            deselectionDate: null,
            topOptionsConcepts: [],
            totalDocCount: 0,
        }},
    reducers: {
        loadDashboard: (state, action) => {
            const id = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
        },
        setTopFilters: (state, action) => {
            const { id, filters } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].topFilters = filters;
        },
        setTopConcepts: (state, action) => {
            const { id, concepts } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].topConcepts = concepts;
        },
        setSelections: (state, action) => {
            const { id, selections } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].selections = { ...state[id].selections, ...selections };
        },
        resetSelections: (state, action) => {
            const { id } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].selections = {};
            state[id].topConcepts = [];
            state[id].topFilters = [];
        },
        setTopConceptList: (state, action) => {
            const { id, list } = action.payload;
            if (list===null){
                state[id].topConceptList = ''
            }
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }

            state[id].topConceptList = list;
        },
        setTopConceptListDaylight: (state, action) => {
            const { id, daylight } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].topConceptListDaylight = daylight;
        },
        setActiveConceptList: (state, action) => {
            const { id, list } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            if (list?.startsWith("Type: ")) {
                state[id].activeConceptList =  list.replace("Type: ", "");
                state[id].topConceptListDaylight = list.replace("Type: ", "");
                state[id].topConceptList = "";
            } else {
                state[id].activeConceptList = list;
                state[id].topConceptListDaylight = "";
                state[id].topConceptList = list;
            }
        },

        saveToLocalStorage: (state, action) => {
            const id = action.payload;
            if (state[id]) {
                localStorage.setItem(`dashboardState-${id}`, JSON.stringify(state[id]));
            }
        },
        setDeselection: (state, action) => {
            const { id, deselection } = action.payload;
            if (!state[id].filterState) {
                state[id].filterState = {
                    deselection: "",
                    deselectionConcepts: "",
                    deselectionDate: null,
                };
            }
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].filterState.deselection = deselection;
        },
        setDeselectionConcepts: (state, action) => {
            const { id, deselectionConcepts } = action.payload;
            if (!state[id].filterState) {
                state[id].filterState = {
                    deselection: "",
                    deselectionConcepts: "",
                    deselectionDate: null,
                };
            }
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            state[id].filterState.deselectionConcepts = deselectionConcepts;
        },
        setDeselectionDate: (state, action) => {
            const { id, deselectionDate } = action.payload;
            if (!state[id]) {
                state[id] = loadDashboardState(id);
            }
            if (!state[id].filterState) {
                state[id].filterState = {
                    deselection: "",
                    deselectionConcepts: "",
                    deselectionDate: null,
                };
            }
            state[id].filterState.deselectionDate = deselectionDate;
        },
    },
});


export const {
    loadDashboard,
    setTopFilters,
    setTopConcepts,
    setSelections,
    resetSelections,
    setActiveConceptList,
    setTopConceptList,
    setTopConceptListDaylight,
    saveToLocalStorage,
    setDeselection,
    setDeselectionConcepts,
    setDeselectionDate,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
